import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <>
      <section className="hero">
        <h1>Log Every AI Interaction. Stay Compliant.</h1>
        <p>IQLedger is a drop-in SDK that captures LLM prompts and responses, redacts PII, and generates compliance reports for the EU AI Act and SOC 2 automatically.</p>
        
        <div className="hero-buttons">
          <a 
            href="https://www.nuget.org/packages/IQLedger.Sdk" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="cta-button"
          >
            Get the SDK
          </a>
          <Link to="/docs" className="cta-button cta-button-secondary">
            View Documentation
          </Link>
        </div>
      </section>

      <section className="page">
        <h2>Why IQLedger?</h2>
        <p>Most teams building with LLMs don't have proper visibility into what data is being processed. IQLedger solves that with a simple .NET SDK and a dashboard that makes compliance and debugging effortless.</p>

        <h2>Who It's For</h2>
        <div className="checklist">
          <div>Teams using OpenAI, Anthropic, or custom models in production</div>
          <div>Companies needing GDPR, SOC 2, or EU AI Act compliance</div>
          <div>Developers who hate reinventing logging + redaction + audit trails</div>
        </div>
      </section>
    </>
  );
}

export default Home;
